const loadIframe = (iframes) => {
  const checkChatWidgetLoaded = () => {
    if (window.fcWidget) {
      window.fcWidget.on('widget:loaded', function () {
        iframes.each((index, iframe) => {
          $(iframe).siblings('.lazy-image-wrapper').addClass('hide');
          $(iframe).removeClass('hide');
          iframe.src = iframe.dataset.src;
        });
      });
    } else {
      setTimeout(checkChatWidgetLoaded, 100);
    }
  };
  checkChatWidgetLoaded();
};

const loadIframeInit = () => {
  const iframes = $('.custom-iframe-banner.lazy-load');
  if (iframes.length) loadIframe(iframes);
};

export { loadIframeInit };
